export const targetTaskMark = (event: Event) => {
  const eventTarget = event.target as HTMLElement
  const parentTaskMark = findUndresolvedTaskMark(eventTarget)
  if (parentTaskMark && eventTarget.dataset?.visible === 'true') {
    return parentTaskMark as HTMLElement
  }
  return null
}

export const UNRESOLVED_TASK_MARK_SELECTOR = "[data-type='todo'][data-resolved='false']"
export const findUndresolvedTaskMark = (element: HTMLElement): HTMLElement | undefined => {
  let parentElement: HTMLElement | null = element
  while (parentElement) {
    if (parentElement.matches(UNRESOLVED_TASK_MARK_SELECTOR)) {
      return parentElement
    }
    parentElement = parentElement.parentElement
  }
}

export const findAllTasksMarks = (uuid?: string | null): ReturnType<typeof document.querySelectorAll> =>
  document.querySelectorAll(`[data-type='todo'][data-uuid='${uuid}']`)
